import styling from "./AgGrid.module.scss";
import clsx from "clsx";
import { AgGridReact, type AgGridReactProps } from "ag-grid-react";
import { ModuleRegistry, AllEnterpriseModule, type CellClickedEvent, type CellValueChangedEvent } from "ag-grid-enterprise";
import { RowGroupingModule, RowGroupingPanelModule } from "ag-grid-enterprise";
import React from "react";
import { theme } from "../theme";
import "./AgGrid.scss";

ModuleRegistry.registerModules([AllEnterpriseModule, RowGroupingModule, RowGroupingPanelModule]);

export type AgColumnDef = {
	field?: string;
	headerName?: string;
	cellRenderer?: React.ReactNode;
};

export interface IAgGrid<TData> extends AgGridReactProps<TData> {
	id?: string;
	className?: string;
	debug?: boolean;
	pagination?: boolean;
	disableFiltering?: boolean;
	suppressHeaderMenuButton?: boolean;
	onCellClicked?: (event: CellClickedEvent<any, any>) => void;
	onCellValueChanged?: (event: CellValueChangedEvent<any, any>) => void;
}

export const AgGrid = <TData,>(props: IAgGrid<TData>) => {
	const {
		id,
		className,
		detailCellRendererParams,
		pagination = false,
		debug = false,
		disableFiltering = false,
		suppressHeaderMenuButton = false,
		rowData,
		columnDefs,
		onCellClicked,
		onCellValueChanged,
		masterDetail = true,
		...rest
	} = props;

	const config = {
		defaultColDef: {
			flex: 1,
			sortable: true,
			filter: !disableFiltering,
			resizable: true,
			suppressHeaderMenuButton: suppressHeaderMenuButton,
		},
	};

	return (
		<div
			id={id}
			className={clsx(styling.wrapper, {
				[`${className}`]: className,
			})}
		>
			<AgGridReact
				{...config}
				theme={theme}
				animateRows={false}
				suppressMovableColumns={true}
				rowBuffer={10}
				rowHeight={50}
				detailCellRendererParams={detailCellRendererParams}
				rowSelection={{ mode: "singleRow" }}
				detailRowAutoHeight={true}
				masterDetail={masterDetail}
				pagination={pagination}
				debug={debug}
				className={styling["grid"]}
				columnDefs={columnDefs}
				rowData={rowData}
				onCellClicked={onCellClicked}
				onCellValueChanged={onCellValueChanged}
				{...rest}
			/>
		</div>
	);
};
